module.exports = __webpack_public_path__ + "1791188489487/fonts/Flaticon.5b09159.ttf";